// extracted by mini-css-extract-plugin
export var icon = "_6c-1";
export var subtext = "_6c-0";